<template>
  <sa-page-layout :showModalLoading="showModalLoading" :btnNewVisible="btnNewVisible" :linkedit="linkedit">
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col sm="6">
            <b-form-input v-model="filtro.paziente" type="search" id="nome" :placeholder="this.$i18n.t('adi.lblFirstNameESecondName')"></b-form-input>
          </b-col>
          <b-col sm="6">
            <b-form-input v-model="filtro.codiceFiscale" type="search" id="codiceFiscale" :placeholder="this.$i18n.t('adi.lblFiscalCode')"></b-form-input>
          </b-col>
        </b-row>
        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem"> </b-row>
        <b-row>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-header">
      <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col cols="6">
          <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col cols="6">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </template>
    <template slot="table-body">
      <div class="b-table-sticky-header">
        <b-table sticky-header ref="table" responsive stacked="lg" striped hover :items="items" :filter="filtro" :fields="fields" sort-icon-left head-variant="light" class="sa-b-table">
          <template v-slot:cell(codiceFiscale)="{ item }">
            <router-link class="sa-edit-link" :to="'/adi/dimissioniprotette/edit/' + item.id"> {{ item.codiceFiscale }} </router-link>
          </template>
          <template v-slot:cell(paziente)="{ item }">
            <a> {{ item.nome }} {{ item.cognome }} </a>
          </template>
        </b-table>
      </div>
    </template>
    <template slot="table-footer">
      <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col cols="6">
          <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col cols="6">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  mixins: [UtilityMixin],
  components: { SaPageLayout },
  data() {
    return {
      filtro: {},
      currentPage: 1,
      perPage: 50,
      rows: null,
      showModalLoading: false,
      btnNewVisible: true,
      pathResource: "/adidimissioniprotette",
      linkedit: "/adi/dimissioniprotette",
      sezioneDimissioniProtette: "adidimissioniprotette",
      items: [],
      fields: [
        {
          label: this.getLabelTraduora("adi.lblFiscalCode"),
          key: "codiceFiscale",
          sortable: true,
        },
        {
          label: this.getLabelTraduora("adi.lblPatient"),
          key: "paziente",
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.linkedit = "/adi/dimissioniprotette";
    me.impostaPermessi();
    me.loadData();
  },
  methods: {
    impostaPermessi() {
      let me = this;
      me.btnNewVisible = UtilityMixin.methods.verificaPermessi(me.utente, me.sezioneDimissioniProtette, 2) || UtilityMixin.methods.verificaPermessi(me.utente, me.sezioneDimissioniProtette, 4);
    },
    loadData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource;
      me.filtro.forPage = me.perPage;
      me.filtro.page = me.currentPage;
      me.showModalLoading = true;
      axios
        .get(link, { params: me.filtro })
        .then((response) => {
          me.items = [];
          me.rows = response.data.data.recordsNumber;
          me.items = response.data.data.list;
          me.showModalLoading = false;
        })
        .catch((error) => {
          me.showModalLoading = false;
          this.$bvModal
            .msgBoxOk(link + " \n" + error.message, {
              title: "ATTENZIONE",
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "sa-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch((err) => {
              console.log(err);
            });
        });
    },
    onSubmit() {
      let me = this;
      let sessionStorage = window.sessionStorage;
      sessionStorage["filtro"] = JSON.stringify(me.filtro);
      me.loadData();
    },
    onReset() {
      let me = this;
      me.filtro = {};
      let sessionStorage = window.sessionStorage;
      sessionStorage["filtro"] = JSON.stringify(me.filtro);
      me.loadData();
    },
  },
};
</script>
